import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { ChangeEventHandler } from 'react';
import { Undo } from '@mui/icons-material';

export const AdvancedFields: React.FC<{
  bakIntegration: boolean;
  bucketName: string;
  serverAddress: string;
  realmId: string | undefined;
  handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClickUndo: () => void;
}> = ({
  bakIntegration,
  handleCheckboxChange,
  serverAddress,
  bucketName,
  realmId,
  onChange,
  onClickUndo,
}) => {
  return (
    <Box display="flex" flexDirection={'column'} marginTop={6} marginBottom={6}>
      <FormControlLabel
        control={
          <Checkbox
            checked={bakIntegration}
            onChange={handleCheckboxChange}
            name="bakIntegration"
            color="primary"
          />
        }
        label="Uses .bak integration"
      />
      <FormControl className="provision-field">
        <TextField
          id="bucket-name"
          label="Bucket Name"
          name="bucketName"
          value={bucketName}
          onChange={onChange}
        />
      </FormControl>
      <FormControl className="provision-field">
        <TextField
          id="server-addresss"
          label="Server Address"
          name="serverAddress"
          value={serverAddress}
          onChange={onChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={onClickUndo}>
                  <Undo />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
      <FormControl className="provision-field">
        <TextField id="realmId" label="Realm" name="realmId" value={realmId} onChange={onChange} />
      </FormControl>
    </Box>
  );
};
